import { useState, useEffect } from 'react';
import { API, Endpoints } from '../api/API';
import { BasicInfo, RegistrationValue, Facility } from '../interfaces/Interfaces';
import { verifyPhone, verifyZip, checkTrailingSpace } from '../js/verificationFunctions';

interface BasicInfoProps {
    email: string,
    formStep: number,
    setFormStep: React.Dispatch<React.SetStateAction<number>>,
    basicInfo: BasicInfo,
    setBasicInfo: React.Dispatch<React.SetStateAction<BasicInfo>>,
    userType: "customer" | "independent" | "student" | null,
    userCountry: string | null,
    objectId: string | null,
    appId: string | null,
    translate: () => void,
    facZip: string,
    setFacZip: React.Dispatch<React.SetStateAction<string>>,
    setBackgroundWIP: React.Dispatch<React.SetStateAction<boolean>>,
    bdBioSciencesUserType: string | null,
    setBdBioSciencesUserType: React.Dispatch<React.SetStateAction<string | null>>,
    positions: Array<[string, string]>,
    lang: string | null,
    authLocale: string,
    customRegistrationValues: Array<RegistrationValue>,
    updateRegistrationValues: () => void
    appFeatures: any
    hideFields: Array<string>,
    optionalFields: Array<string>
    skipOptionalFacility: Boolean,
    accountID: string,
    token: string,
    facilityOptional: Boolean,
    facilityInfo: Facility,
    setFacilityInfo: (arg0: Facility) => void
}

const BasicInformation = (props: BasicInfoProps) => {
    const CONFIG = require('../config.json')[process.env.NODE_ENV];

    const [requiredInfoError, setRequiredInfoError] = useState<Array<string>>([]);
    const [validationError, setValidationError] = useState<Array<string>>([]); 
    const [facilitiesFromSearch, setFacilitiesFromSearch] = useState<Array<Facility>>();
    const [isSingleFacilityRecord, setIsSingleFacilityRecord] = useState<boolean>(false); 

    useEffect(() => {
        props.translate();
    }, [props.lang]);

    useEffect(() => {
        if(props.accountID != ""){
            props.setBasicInfo({ ...props.basicInfo, accountNumber: props.accountID });
            
            console.log("basic info acc id " + props.accountID);
            //if account number is present, do search facility.
            //If it's only single record, then add it to user object
            getFacilities();
        }
    }, [props.accountID]);

    const getFacilities = async () => {
        props.setBackgroundWIP(true);
        const body = { "ean": props.accountID }
        const data = await API.POST(body, Endpoints.GetFacilities, props.token);
        API.POST(body, Endpoints.GetFacilities, props.token).then(data => {
            setFacilitiesFromSearch(data);
            if (data != null && data.length == 1) {
                console.log('single fac record is ..' + JSON.stringify(data));
                setIsSingleFacilityRecord(true);
                var facSingle = data[0];
                props.setFacilityInfo({ ...facSingle });
            }
        })
        props.setBackgroundWIP(false);
    }                                           

    useEffect(() => {
        props.updateRegistrationValues();
    }, [props.customRegistrationValues])

    useEffect(() => {
        $('.match-height').matchHeight();
    }, [validationError, requiredInfoError]);

    const goNext = () => {
        var currentErrors: Array<string> = [];
        var validationFlag = false;

        //Only checking names for purely empty strings        
        if (!props.hideFields?.includes("firstName") && (!props.basicInfo.firstName || props.basicInfo.firstName.indexOf('\'') >= 0 || props.basicInfo.firstName.indexOf('"') >= 0)) {
            currentErrors = [...currentErrors, "firstName"];
            validationFlag = true;
            
        }
        if (!props.hideFields?.includes("lastName") && (!props.basicInfo.lastName || props.basicInfo.lastName.indexOf('\'') >= 0 || props.basicInfo.lastName.indexOf('"') >= 0)) {
            currentErrors = [...currentErrors, "lastName"];
            validationFlag = true;
            
        }        
        if (!props.hideFields?.includes("phoneNumber") && props.basicInfo.phoneNumber && !verifyPhone(props.basicInfo.phoneNumber)) {
            currentErrors = [...currentErrors, "phoneNumber"];
            validationFlag = true;
           
        }
        if (!props.hideFields?.includes("mobileNumber") && props.basicInfo.mobileNumber && !verifyPhone(props.basicInfo.mobileNumber)) {
            currentErrors = [...currentErrors, "mobileNumber"];
            validationFlag = true;
            
        }
        if (!props.hideFields?.includes("faxNumber") && props.basicInfo.faxNumber && !verifyPhone(props.basicInfo.faxNumber)) {
            currentErrors = [...currentErrors, "faxNumber"];
            validationFlag = true;        
        }
       /* if(!props.skipOptionalFacility && props.optionalFields?.includes("facilityZip")){
            currentErrors = [...currentErrors,"facilityZip"];
            validationFlag = true;
        }*/
        if (!props.hideFields?.includes("facilityZip") && props.facZip && !verifyZip(props.facZip)) {            
            currentErrors = [...currentErrors, "facilityZip"];
            validationFlag = true;            
        }
        
        setValidationError([...currentErrors]);
        
        if (validationFlag || props.basicInfo.firstName === "" || props.basicInfo.lastName === "" || ( !props.hideFields?.includes("phoneNumber") && props.basicInfo.phoneNumber === "" && !props.optionalFields?.includes("phoneNumber")) || 
         (!props.hideFields?.includes("position") && props.basicInfo.position === "" && !props.optionalFields?.includes("position")) ||
         (!props.hideFields?.includes("facilityZip") && props.facZip === "" && !props.optionalFields?.includes("facilityZip")) || (props.bdBioSciencesUserType === "" && props.appId === CONFIG.bdBiosciences)) {
            
            currentErrors = [];            
            if (!props.hideFields?.includes("firstName") && props.basicInfo.firstName === '' && !currentErrors.includes("firstName") && !props.optionalFields?.includes("firstName")) {
                currentErrors = [...currentErrors, "firstName"];                
            }
            if (!props.hideFields?.includes("lastName") && props.basicInfo.lastName === '' && !currentErrors.includes("lastName") && !props.optionalFields?.includes("lastName")) {
                currentErrors = [...currentErrors, "lastName"];                
            }
            if (!props.hideFields?.includes("phoneNumber") && props.basicInfo.phoneNumber === '' && !currentErrors.includes("phoneNumber") && !props.optionalFields?.includes("phoneNumber")) {
                currentErrors = [...currentErrors, "phoneNumber"];
            }
            if (!props.hideFields?.includes("position") && props.basicInfo.position === '' && !currentErrors.includes("position") && !props.optionalFields?.includes("position")) {
                currentErrors = [...currentErrors, "position"];
            }
            if (!props.hideFields?.includes("facilityZip") && props.facZip === "" && !currentErrors.includes("facilityZip") && !props.optionalFields?.includes("facilityZip")) {
                currentErrors = [...currentErrors, "facilityZip"];
            }
            if (props.bdBioSciencesUserType === "" && !currentErrors.includes("facilityZip") && props.appId === CONFIG.bdBiosciences) {
                currentErrors = [...currentErrors, "bioscienceUser"];
            }

            setRequiredInfoError([...currentErrors]);
                        
        } else {            
            // If it matches the US 9 digit zip format (5 digits - 4 digits) then only take the first 5 for now
            if (props.facZip.match(/^\d{5}-\d{4}$/gm)) props.setFacZip(props.facZip.substring(0, 5));

            setRequiredInfoError([]);
            props.setFormStep(props.formStep + 1);
        }
        
    }


    return (
        <div id="basic-information">
            <p className={requiredInfoError.length === 0 ? "hide" : "accent-1-text"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="664eebfb-9b9d-488f-9778-2f09ffa5f99b">Please provide your</span> {requiredInfoError.map((value, index) => { return (index === 0 ? '' : ', ') + ($(`option#${value}`).length > 0 ? value.charAt(0).toUpperCase() + value.slice(1) : $(`#${value}`).attr('placeholder')); })}.
            </p>
            <p className={validationError.includes("firstName") && !requiredInfoError.includes("firstName") && !props.hideFields?.includes("firstName") && !props.optionalFields?.includes("firstName")? "accent-1-text" : "hide"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="3a0768df-1dcf-40f0-abbf-55e63e4fcb3e">Please ensure your first name is not just blank space.</span>
            </p>
            <p className={validationError.includes("lastName") && !requiredInfoError.includes("lastName") && !props.hideFields?.includes("lastName") && !props.optionalFields?.includes("lastName") ? "accent-1-text" : "hide"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="6d929587-c859-4184-84c7-505ca2fa05ab">Please ensure your last name is not just blank space.</span>
            </p>
            <p className={validationError.includes("phoneNumber") && !requiredInfoError.includes("phoneNumber") && !props.hideFields?.includes("phoneNumber") && !props.optionalFields?.includes("phoneNumber")? "accent-1-text" : "hide"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="e8798137-a084-4bcd-860a-75ed727f4cc0">Please ensure your phone number is a valid phone number.</span>
            </p>
            <p className={validationError.includes("mobileNumber") ? "accent-1-text" : "hide"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="270fc42e-1732-4840-94cb-5125c795472d">Please ensure your mobile number is a valid phone number.</span>
            </p>
            <p className={validationError.includes("faxNumber") ? "accent-1-text" : "hide"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="eab0bf1b-dfd3-4ad7-b211-04dbb6c2b3bd">Please ensure your fax number is a valid phone number.</span>
            </p>
            <p className={validationError.includes("facilityZip") && !requiredInfoError.includes("facilityZip") && !props.hideFields?.includes("facilityZip") && !props.optionalFields?.includes("facilityZip") ? "accent-1-text" : "hide"}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility zipcode contains only numbers and hyphens.</span>
            </p>
            <form>
                <div className="row">
                    <div className="col-sm-6">
                        <span className="5877b28e-c675-4e6b-a5f5-071bec77bfbf">Email Address:</span> {props.email}
                    </div>
                </div>
                <div className="row">
                    <div className={!props.hideFields?.includes("firstName")? "col-sm-6" :"hide"}>
                        <p>
                            <label className="42074b15-913c-4b06-9035-77e444b5e9fb requiredLabel firstName">First Name</label>
                            {!props.optionalFields?.includes("firstName")? <span className='requiredIcon'> *</span> : <></> }                            
                            <input
                                type='text'
                                placeholder="First Name"
                                id="firstName"
                                className={requiredInfoError.includes("firstName") || validationError.includes("firstName") ? 'error 42074b15-913c-4b06-9035-77e444b5e9fb' : '42074b15-913c-4b06-9035-77e444b5e9fb'}
                                value={props.basicInfo.firstName}
                                onBlur={checkTrailingSpace(
                                    (e) => props.setBasicInfo({ ...props.basicInfo, firstName: e.target.value })
                                )}
                                onChange={(e) => props.setBasicInfo({ ...props.basicInfo, firstName: e.target.value })}
                                required
                            />
                        </p>
                    </div>
                    <div className={!props.hideFields?.includes("lastName")? "col-sm-6" :"hide"}>
                        <p>
                            <label className="8ee1d75c-5cf4-409a-bf59-11e5d850254b requiredLabel lastName">Last Name</label>
                            {!props.optionalFields?.includes("lastName")? <span className='requiredIcon'> *</span> : <></> }
                            <input
                                type='text'
                                placeholder="Last Name"
                                id="lastName"
                                className={requiredInfoError.includes("lastName") || validationError.includes("lastName") ? 'error 8ee1d75c-5cf4-409a-bf59-11e5d850254b' : '8ee1d75c-5cf4-409a-bf59-11e5d850254b'}
                                value={props.basicInfo.lastName}
                                onBlur={checkTrailingSpace(
                                    (e) => props.setBasicInfo({ ...props.basicInfo, lastName: e.target.value })
                                )}
                                onChange={(e) => props.setBasicInfo({ ...props.basicInfo, lastName: e.target.value })}
                                required
                            />
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className={!props.hideFields?.includes("phoneNumber")? "col-sm-6" :"hide"}>
                        <p>
                            {!props.optionalFields?.includes("phoneNumber") ? <><label className="4a3a2ad6-f75b-4e8c-9553-186b7904a26c requiredLabel phoneNumber">Phone Number</label>
                                <span className='requiredIcon'> *</span>
                                <input
                                    type='text'
                                    placeholder="Phone Number"
                                    id="phoneNumber"
                                    className={requiredInfoError.includes("phoneNumber") || validationError.includes("phoneNumber") ? 'error 4a3a2ad6-f75b-4e8c-9553-186b7904a26c' : '4a3a2ad6-f75b-4e8c-9553-186b7904a26c'}
                                    value={props.basicInfo.phoneNumber}
                                    onBlur={checkTrailingSpace(
                                        (e) => props.setBasicInfo({ ...props.basicInfo, phoneNumber: e.target.value })
                                    )}
                                    onChange={(e) => props.setBasicInfo({ ...props.basicInfo, phoneNumber: e.target.value })}
                                    required
                                /></>
                                : <><label className="4a3a2ad6-f75b-4e8c-9553-186b7904a26c requiredLabel phoneNumber">Phone Number</label>
                                    <input
                                        type='text'
                                        placeholder="Phone Number"
                                        id="phoneNumber"
                                        className={validationError.includes("phoneNumber") ? 'error 4a3a2ad6-f75b-4e8c-9553-186b7904a26c' : '4a3a2ad6-f75b-4e8c-9553-186b7904a26c'}
                                        value={props.basicInfo.phoneNumber}
                                        onBlur={checkTrailingSpace(
                                            (e) => props.setBasicInfo({ ...props.basicInfo, phoneNumber: e.target.value })
                                        )}
                                        onChange={(e) => props.setBasicInfo({ ...props.basicInfo, phoneNumber: e.target.value })}

                                    /></>}
                        </p>
                    </div>
                    <div className={!props.hideFields?.includes("mobileNumber")? "col-sm-6" :"hide"}>
                        <p>
                            <label className="271f4a0b-7fcb-4785-a882-16d4b45087fe mobilePhone">Mobile Phone</label>
                            <input
                                type='text'
                                placeholder="Mobile Phone- Optional"
                                className={validationError.includes("mobileNumber") ? 'error 271f4a0b-7fcb-4785-a882-16d4b45087fe' : '271f4a0b-7fcb-4785-a882-16d4b45087fe'}
                                value={props.basicInfo.mobileNumber}
                                onBlur={checkTrailingSpace(
                                    (e) => props.setBasicInfo({ ...props.basicInfo, mobileNumber: e.target.value })
                                )}
                                onChange={(e) => props.setBasicInfo({ ...props.basicInfo, mobileNumber: e.target.value })}
                            />
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className={!props.hideFields?.includes("faxNumber")? "col-sm-6" :"hide"}>
                        <p>
                            <label className='c30e1d29-7ccf-4695-b722-f129414ebd36 faxNumber'>Fax Number</label>
                            <input
                                type='text'
                                placeholder="Fax Number- Optional"
                                className={validationError.includes("faxNumber") ? 'error c30e1d29-7ccf-4695-b722-f129414ebd36' : 'c30e1d29-7ccf-4695-b722-f129414ebd36'}
                                value={props.basicInfo.faxNumber}
                                onBlur={checkTrailingSpace(
                                    (e) => props.setBasicInfo({ ...props.basicInfo, faxNumber: e.target.value })
                                )}
                                onChange={(e) => props.setBasicInfo({ ...props.basicInfo, faxNumber: e.target.value })}
                            />
                        </p>
                    </div>
                    <div className={!props.hideFields?.includes("position")? "col-sm-6" :"hide"}>
                        <p>
                            <label className='1d1d5243-811c-4e30-a61e-c06fe8ea8a46  requiredLabel position'>Position</label>
                            {!props.optionalFields?.includes("position")? <span className='requiredIcon'> *</span> : <></> }
                            <select name="positionsSelect"
                                className={requiredInfoError.includes("position") ? 'error' : ''} id="position" value={props.basicInfo.position}
                                onChange={(e: any) => {console.log("Position Select Event: "+ e.target.value);props.setBasicInfo({ ...props.basicInfo, position: e.target.value })}}
                            >
                                <option value="" hidden disabled className="1d1d5243-811c-4e30-a61e-c06fe8ea8a46" id="position">Position</option>
                                {props.positions.map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value}
                                    </option>
                                ))}

                            </select>
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className={!props.hideFields?.includes("department")? "col-sm-6" :"hide"}>
                        <p>
                            <label className='e1dcae07-36a4-4045-9469-835fb2b1a4eb department'>Department</label>
                            <input
                                type='text'
                                placeholder="Department - Optional"
                                className='e1dcae07-36a4-4045-9469-835fb2b1a4eb'
                                id="department"
                                value={props.basicInfo.department}
                                onBlur={checkTrailingSpace(
                                    (e) => props.setBasicInfo({ ...props.basicInfo, department: e.target.value })
                                )}
                                onChange={(e) => props.setBasicInfo({ ...props.basicInfo, department: e.target.value })}
                            />
                        </p>
                    </div>
                    <div className="col-sm-6">
                        <p>
                            <label className='c37ba348-ec9b-46ab-8918-81c4d7fa8c72 accountNumber'>Account number (if known)</label>
                            <input
                                type='text'
                                placeholder="Account number (if known)- Optional"
                                className='c37ba348-ec9b-46ab-8918-81c4d7fa8c72'
                                maxLength={15}
                                value={props.basicInfo.accountNumber}
                                onBlur={checkTrailingSpace(
                                    (e) => props.setBasicInfo({ ...props.basicInfo, accountNumber: e.target.value })
                                )}
                                onChange={(e) => props.setBasicInfo({ ...props.basicInfo, accountNumber: e.target.value })}
                            />
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className={!props.hideFields?.includes("facilityZip")? "col-sm-6" :"hide"}>
                        <p>
                            <label className="bf996cf8-5aa3-40e0-97b7-05ec72e8012b requiredLabel facilityZip">Facility Zip/ Postal Code</label>
                            {!props.optionalFields?.includes("facilityZip")? <span className='requiredIcon'> *</span> : <></> }                            
                            <input
                                type='text'
                                placeholder="Facility Zip/ Postal Code"
                                className={requiredInfoError.includes("facilityZip") || validationError.includes("facilityZip") ? 'error bf996cf8-5aa3-40e0-97b7-05ec72e8012b' : 'bf996cf8-5aa3-40e0-97b7-05ec72e8012b'}
                                id="facilityZip"
                                value={props.facZip}
                                onBlur={checkTrailingSpace((e) => props.setFacZip(e.target.value))}
                                onChange={(e) => props.setFacZip(e.target.value )}
                            />
                        </p>
                    </div>
                    <div className={props.appId === CONFIG.bdBiosciences ? "col-sm-6" : "hide"}>
                        <p>
                            <select name="bioscienceUserType" className={''} value={props.bdBioSciencesUserType !== null ? props.bdBioSciencesUserType : "Purchasing"} onChange={(e: any) => props.setBdBioSciencesUserType(e.target.value)}>
                                <option className='2ffc50a4-95ac-44be-abe7-cb75d77738b9' value="" id="bioscienceUser" hidden disabled> BD Biosciences User Type </option>
                                <option className="a4dc6342-abbc-480d-bead-872fdb4cc2f9" value="Purchasing" title="">Purchasing</option>
                                <option className='721ff44b-8ed0-49d0-b3dd-e1f9603659cd' value="Guest" title="">Guest</option>
                                <option className='995465b6-a06a-4171-86c3-3c642ab9205c' value="OrderInquiry" title="">Order Inquiry</option>
                            </select>
                        </p>
                    </div>
                </div>
            </form>
            <div className="spacer"></div>
            <p className="buttons align-right">
                <button id="continue" className="button 394b58c5-ee63-4444-978a-c0373030b4f2" onClick={goNext}>Continue</button>
            </p>
        </div>
    )
}

export default BasicInformation
